import React, { PureComponent } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { Tab, Tabs } from '@dbk/ui-tabs';
import { Large, Small } from '@dbk/ui-text';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import { PDF } from '@dbk/ui-icons';
import Spinner from '@dbk/ui-spinner';
import Button from '@dbk/ui-buttons';
import format from 'date-fns/format';
import { AccordionPlusIcon, AccordionMinusIcon } from '../../../components/common/icons';
import { PALETTE, DOCSIGN_CONSTANTS, DOCSIGN_STATUS, PAGE } from '../../../constants';
import styles from './document-list.styles';
import AcceptSignModal from '../signing/accept-sign-modal';
import DocuSignModal from '../signing/docusign-modal';
import Pagination from '../../../components/common/pagination';
import SimpleDate from '../../../components/common/date';

const initialPageState = {
  pageNumber: 0,
  pageOffset: 0
}

let pageNum = 0;
class DocumentList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      openedDocument: {},
      totalRecords: 0,
    };

    this.renderTabs = this.renderTabs.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.viewPDF = this.viewPDF.bind(this);
    this.getColoredStatus = this.getColoredStatus.bind(this);
    this.setPageOffset = this.setPageOffset.bind(this);
    this.prepareDocumentList = this.prepareDocumentList.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
  }

  componentDidMount() {
    this.onChangeTab(0);
  }

  componentDidUpdate(prevProps) {
    const {
      docsign: { documentListResponse },
      app: { user: { selectedPortfolioId } }
    } = this.props;
    if (prevProps.docsign.documentListResponse !== documentListResponse && documentListResponse !== undefined) {
      this.prepareDocumentList(documentListResponse);
    }
    if (prevProps.app.user.selectedPortfolioId !== selectedPortfolioId) {
      this.onChangeTab(0);
    }
  }

  onChangeTab = (tabIndex) => {
    this.props.resetVariables();
    this.setState({ selectedIndex: tabIndex });
    if (tabIndex === 0) {
      this.props.getDocumentList(DOCSIGN_CONSTANTS.PENDING_ACTION, initialPageState.pageNumber);
    } else {
      this.props.getDocumentList(DOCSIGN_CONSTANTS.OTHERS, initialPageState.pageNumber);
    }
    this.setPageOffset(initialPageState.pageNumber);
  }

  viewPDF(document) {
    if (document.enableDocuSign === 'Y') {
      this.props.docusignaccept.setShowDocusignModal(true);
      this.props.docusignaccept.setdocuSignURLResponseError('');
      this.props.docusignaccept.setcompleteDocumentSignResponseError('');
      this.props.docusignaccept.resetSignedDocumentVariables();

      this.setState({
        openedDocument: document
      })

    } else {
      this.props.docsign.setShowAcceptSignModal(true);
      this.props.acceptsign.setAcceptViewResponseError('');
      this.props.acceptsign.setactionAcceptResponseError('');

      this.setState({
        openedDocument: document
      })
    }
  }

  renderTabs() {
    const { selectedIndex } = this.state;
    const { i18n: { messages } } = this.props;
    const tabStrings = [messages['app.docsign.pendingTabText'], messages['app.docsign.allTabText']];

    return (
      <Tabs
        secondary
        handleSelectedIndex={this.onChangeTab}
        selectedIndex={selectedIndex}
        stretch
      >
        {tabStrings.map((string, i) => (
          <Tab
            renderLabel={() => (
              <Large
                secondary
                style={
                  selectedIndex === i ?
                    StyleSheet.flatten(styles.tabStyleSelected)
                    :
                    StyleSheet.flatten(styles.tabStyle)
                }
              >
                {string}
              </Large>
            )}
          />
        ))}
      </Tabs>
    );
  }

  renderHeader() {
    const { selectedIndex } = this.state;
    const { i18n: { messages } } = this.props;
    const dateText = selectedIndex === 0 ? 'app.docsign.dueDateText' : 'app.docsign.statusDateText';

    return (
      <div className="header-container-border">
      <View style={styles.headerContainer}>
        <Text style={styles.headerDocument}>{messages['app.docsign.documentText']}</Text>
        <Text style={styles.headerDate}>{messages[dateText]}</Text>
      </View>
     </div>
    );
  }

  getColoredStatus(document) {
    switch (document.signStatus) {
      case DOCSIGN_STATUS.BANK_VERIFIED:
        return '#4CBA38';

      case DOCSIGN_STATUS.PENDING:
      case DOCSIGN_STATUS.EXPIRED:
      case DOCSIGN_STATUS.PULLED_BACK:
      case DOCSIGN_STATUS.PENDING_VERIFICATION:
        return 'white';

      case DOCSIGN_STATUS.CLIENT_REJECTED:
      case DOCSIGN_STATUS.BANK_REJECTED:
        return '#FF3838';

      default:
        return 'white';
    }
  }

  getStatusText(signStatus) {
    switch (signStatus) {
      case DOCSIGN_STATUS.BANK_VERIFIED:
        return 'app.docsign.status.bankVerifiedText';
      case DOCSIGN_STATUS.PENDING:
        return 'app.docsign.status.pendingVerificationText';
      case DOCSIGN_STATUS.EXPIRED:
        return 'app.docsign.status.expiredText';
      case DOCSIGN_STATUS.PULLED_BACK:
        return 'app.docsign.status.pulledBackText';
      case DOCSIGN_STATUS.PENDING_VERIFICATION:
        return 'app.docsign.status.pendingVerificationText';
      case DOCSIGN_STATUS.CLIENT_REJECTED:
        return 'app.docsign.status.clientRejectedText';
      case DOCSIGN_STATUS.BANK_REJECTED:
        return 'app.docsign.status.bankRejectedText';
    }
  }

  prepareDocumentList(documentListResponse) {
    this.setState({ totalRecords: documentListResponse.totalNumberOfRecords });
  }

  async setPageOffset(newOffset) {
    const pageNumber = newOffset === 0 ? 0 : newOffset / PAGE.pageSize;
    pageNum = pageNumber;
    await this.props.setPageParams({ pageNumber, pageOffset: newOffset });

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onPageChange() {
    const { selectedIndex } = this.state;
    const { PENDING_ACTION, OTHERS } = DOCSIGN_CONSTANTS;
    const status = selectedIndex === 0 ? PENDING_ACTION : OTHERS;
    this.props.getDocumentList(status, pageNum);
  }

  render() {
    const { selectedIndex } = this.state;
    const {
      i18n: { messages },
      docsign: {
        documentList,
        gettingDocuments,
        errorMessage,
        showAcceptSignModal,
        pageOffset,
      },
      docusignaccept: { showDocusignModal },
    } = this.props;

    const minusIcon = <View style={styles.accordionMinusIconStyle}><AccordionMinusIcon /></View>;

    return (
      <div className="docsign row">
        <div className="document-list-title">{messages['app.docsign.eSignatureText']}</div>
        {this.renderTabs()}
        {this.renderHeader()}
        {gettingDocuments ?
          <div className="center-content">
            <Spinner />
          </div>
          :
          <div className="margin-top-30">
            <Accordion
              renderIconForOpen={() => minusIcon}
              renderIconForClose={() => <AccordionPlusIcon />}
            >
              {documentList.map((document, i) => (
                <AccordionItem
                  renderTitle={() => (
                    <View style={styles.accordionTitleContainer}>
                      <View style={styles.accordionTitleFirstRow}>
                        <View style={styles.accordionTitleFirstColumn}>
                          <Text style={styles.accordionTitleText}>{document.docName}</Text>
                          <Text style={styles.accordionTitleText}>{document.docType}</Text>
                        </View>
                        <View style={styles.accordionTitleSecondColumn}>
                        {document.targetDate === null && selectedIndex === 0 ?  <Text style={styles.accordionTitleText}>-</Text> : <Text style={styles.accordionTitleText}>
                            <SimpleDate
                              renderProps={{
                                style: styles.accordionTitleText,
                              }}
                              value={format(
                                selectedIndex === 0 ?
                                  document.targetDate
                                  :
                                  document.modifiedDate
                                ,
                                'MMM DD, YYYY'
                              )} />
                            {', '}
                            {format(
                              selectedIndex === 0 ?
                                document.targetDate
                                :
                                document.modifiedDate
                              ,
                              'hh:mm A'
                            )}
                          </Text>}
                        </View>
                      </View>
                      {selectedIndex !== 0 &&
                        <View style={styles.accordionDetailText}>
                          <Text>{messages['app.docsign.statusText']}</Text>
                          <Text style={{ color: this.getColoredStatus(document) }}>
                            {messages[this.getStatusText(document.signStatus)]}
                          </Text>
                        </View>
                      }
                    </View>
                  )}
                  itemKey={i}
                  key={i}
                >
                  <View style={styles.accordionDetailContainer}>
                    <Text style={styles.accordionDetailText}>
                      {messages['app.docsign.postedDateText']}
                      <SimpleDate value={format(document.postedDate, 'MMM DD, YYYY')} />
                    </Text>
                    {document.rmMessage &&
                      <Text style={styles.accordionDetailText}>
                        {messages['app.docsign.rmCommentsText']}{document.rmMessage}
                      </Text>
                    }
                    <div className="clearfix large-12 margin-bottom-20">
                      <div className="float-left" />
                      <div className="margin-right-70 float-right">
                      <Button
                        fullWidth
                        onPress={() => this.viewPDF(document)}
                      >
                        <PDF
                          width={20}
                          height={20}
                          color={PALETTE.secondaryActive}
                        />
                        {messages['app.docsign.viewDocumentText']}
                      </Button>
                      </div>
                    </div>
                  </View>
                </AccordionItem>
              ))}
            </Accordion>
            {documentList.length !== 0 &&
              <div className="pad-top-10 text-align-right">
                <Small className="secondary">{messages['app.docsign.footerText']}</Small>
              </div>
            }
            {documentList.length !== 0 &&
              <Pagination
                pageOffset={pageOffset}
                pageSize={PAGE.pageSize}
                totalRecords={this.state.totalRecords}
                setPageOffset={this.setPageOffset}
                onPageChange={this.onPageChange}
                style={{ marginVertical: 20, justifyContent: 'flex-end' }}
              />
            }
          </div>
        }
        {errorMessage &&
          <div className="padding-left-14 center-content">
            <Large>{errorMessage}</Large>
          </div>
        }
        {showAcceptSignModal &&
          <AcceptSignModal document={this.state.openedDocument} />
        }
        {showDocusignModal &&
          <DocuSignModal document={this.state.openedDocument} />
        }
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    getDocumentList: { $call: 'docsign.getDocumentList' },
    docsign: {
      documentListResponse: true,
      documentList: true,
      gettingDocuments: true,
      errorMessage: true,
      showAcceptSignModal: true,
      setShowAcceptSignModal: { $set: 'showAcceptSignModal' },
      pageNumber: true,
      pageOffset: true,
    },
    setPageParams: { $call: 'docsign.setPageParams' },
    acceptsign: {
      actionAcceptResponseSuccess: true,
      actionRejectModal: true,
      setAcceptViewResponseError: { $set: 'acceptViewResponseError' },
      setactionAcceptResponseError: { $set: 'actionAcceptResponseError' }
    },
    resetVariables: { $call: 'docsign.resetVariables' },
    downloadDocument: { $call: 'acceptsign.getAcceptView' },
    getSignedDocument: { $call: 'docusignaccept.getSignedDocument' },
    docusignaccept: {
      setdocuSignURLResponseError: { $set: 'docuSignURLResponseError' },
      setcompleteDocumentSignResponseError: { $set: 'completeDocumentSignResponseError' },
      setShowDocusignModal: { $set: 'showDocusignModal' },
      showDocusignModal: true,
      completeDocumentSignResponse: true,
      completeDocumentSignResponseSuccess: true,
      resetSignedDocumentVariables: { $call: 'resetSignedDocumentVariables' },
    },
    app: {
      user: {
        selectedPortfolioId: true
      },
    },
  },
})(DocumentList);
